jQuery(document).ready(function(){
   jQuery('.ct_variant_change').on('change',function(){      
    var optionSelected = $("option:selected", this);
     
     var op1=jQuery.trim($(".ct_variant_0 .ct_variant_change option:selected").text());
     var op2=jQuery.trim($(".ct_variant_1 .ct_variant_change option:selected").text());
     var op3=jQuery.trim($(".ct_variant_2 .ct_variant_change option:selected").text());
     
console.log(op1+" == "+op2+" == "+op3);
  if(op1 != "" && op2 != "" && op3 != "")
  {
    console.log("333333");
    var select_value=op1+" / "+op2+" / "+op3;
   jQuery('.variant-selection__variants option').each(function(){
     var opt=jQuery.trim(jQuery(this).text());     
     if(opt == select_value )
     {
       jQuery('.variant-selection__variants option').removeAttr("selected");
       jQuery(this).attr("selected","selected");
     }
   }) 
  }
  else if(op1 != "" && op2 != "" ) 
  {
    console.log("22222");
    var select_value=op1+" / "+op2
    jQuery('.variant-selection__variants option').each(function(){
     var opt=jQuery.trim(jQuery(this).text());     
     if(opt == select_value )
     {
       jQuery('.variant-selection__variants option').removeAttr("selected");
       jQuery(this).attr("selected","selected");
     }
   }) 
  }
  else if(op1 != "")
  {
    console.log("11111");
    var select_value=op1;
    jQuery('.variant-selection__variants option').each(function(){
     var opt=jQuery.trim(jQuery(this).text());     
     if(opt == select_value )
     {
       jQuery('.variant-selection__variants option').removeAttr("selected");
       jQuery(this).attr("selected","selected");
     }
   }) 
  }  
    var optionSelected = $(" .variant-selection__variants option:selected");
     console.log(optionSelected);
    var dep=optionSelected.attr('data-depth');
     console.log(dep);
     var height=optionSelected.attr('data-height');
     var width=optionSelected.attr('data-width');
      jQuery('.ct_width').text(width);
       jQuery('.ct_height').text(height);
      jQuery('.ct_depth').text(dep);
    
  })
})